import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
    FaChartLine, 
    FaBell, 
    FaUserShield, 
    FaChartBar,
    FaCow,
    FaArrowRight
} from 'react-icons/fa6';
import {FaCheckCircle, FaHeartbeat ,FaMobileAlt } from "react-icons/fa";
import { GiCow, GiBabyBottle, GiMilkCarton } from 'react-icons/gi';
import { MdPregnantWoman, MdDashboard } from 'react-icons/md';
import { PiCowFill } from "react-icons/pi";
import Accueil from '../../screenshots/accueil.png'
import AddAnimal from '../../screenshots/addAnimal.png'
import Animals from '../../screenshots/animalsList.png'
import Croissance from '../../screenshots/croissance.png'
import Reproduction from '../../screenshots/reproductionWheel.png'
import Reproduction2 from '../../screenshots/reproductionWheel2.png'
import Todo from '../../screenshots/TodoList.png'
import Users from '../../screenshots/users.png'
import ModuleRepro from '../../screenshots/ModuleReproduction.png'
import './LandingPage.css';

export default function LandingPage() {
    const navigate = useNavigate();
    const [selectedImage, setSelectedImage] = useState(null);

    const features = [
        {
            icon: <GiCow />,
            title: "Gestion Complète des Animaux",
            description: "Suivez chaque animal avec un profil détaillé incluant race, phase de vie."
        },
        {
            icon: <PiCowFill />,
            title: "Suivi de Reproduction",
            description: "Gérez le cycle complet de reproduction: saillie, gestation, vêlage et croissance des veaux."
        },
        {
            icon: <FaBell />,
            title: "Todo Aujord'hui",
            description: "Ce que vous devez faire aujourd'hui."
        },
        {
            icon: <FaChartBar />,
            title: "Le code bare",
            description: "Chaque animal a son code bare contient ses informations."
        },
        {
            icon: <FaMobileAlt />,
            title: "Accès Mobile",
            description: "Gérez votre exploitation depuis n'importe où avec notre interface responsive."
        },
        {
            icon: <FaUserShield />,
            title: "Multi-Utilisateurs",
            description: "Gérez plusieurs utilisateurs avec différents niveaux d'accès (Admin, Éleveur)."
        }
    ];

    const howItWorks = [
        {
            step: "01",
            title: "Créez votre compte",
            description: "Inscrivez-vous gratuitement et configurez votre ferme en quelques minutes."
        },
        {
            step: "02",
            title: "Ajoutez vos animaux",
            description: "Enregistrez vos animaux avec toutes leurs informations importantes."
        },
        {
            step: "03",
            title: "Suivez & Gérez",
            description: "Utilisez les outils pour gérer la reproduction, les soins, et analyser vos performances."
        }
    ];

    const benefits = [
        {
            icon: <FaCheckCircle />,
            text: "Réduction des pertes de production"
        },
        {
            icon: <FaCheckCircle />,
            text: "Amélioration du taux de réussite de reproduction"
        },
        {
            icon: <FaCheckCircle />,
            text: "Gain de temps dans la gestion quotidienne"
        },
    ];

    const stats = [
        { number: "500+", label: "Animaux Gérés" },
        { number: "100+", label: "Reproductions Suivies" },
        { number: "98%", label: "Satisfaction Client" },
        { number: "24/7", label: "Support Disponible" }
    ];

    const screenshots = [
        { src: Accueil, alt: "Tableau de bord d'accueil" },
        { src: Animals, alt: "Liste des animaux" },
        { src: AddAnimal, alt: "Ajouter un animal" },
        { src: Reproduction, alt: "Roue de reproduction" },
        { src: Reproduction2, alt: "Roue de reproduction" },
        
    ];
    const screenshots2 = [
        { src: ModuleRepro, alt: "Module de reproduction" },
        { src: Croissance, alt: "Suivi de croissance" },
        { src: Todo, alt: "Liste des tâches" },
        { src: Users, alt: "Gestion des utilisateurs" },
        
    ];

    return (
        <div className="landing-page">

            {/* Hero Section */}
            <section className="hero-section">
                <div className="hero-container">
                    <div className="hero-content">
                        <div className="hero-badge">
                            <span className="badge-dot"></span>
                            La Meillieure Plateforme de Gestion d'Élevage
                        </div>
                        <h1 className="hero-title">
                            Gérez Votre Élevage
                            <span className="gradient-text"> Intelligemment</span>
                        </h1>
                        <p className="hero-description1">
                            Une solution complète pour optimiser la gestion de votre exploitation 
                            bovine: suivi des animaux, reproduction, alertes automatiques et statistiques détaillées.
                        </p>
                        <div className="hero-buttons">
                            <button 
                                className="btn-primary"
                                onClick={() => navigate('/signup')}
                            >
                                Commencer Gratuitement
                                <FaArrowRight />
                            </button>
                            <button 
                                className="btn-secondary"
                                onClick={() => navigate('/signin')}
                            >
                                <MdDashboard />
                                Voir la démo
                            </button>
                        </div>
                    </div>
                    <div className="hero-image">
                        <div className="floating-card card-1">
                            <GiCow className="card-icon" />
                            <div>
                                <div className="card-number">245</div>
                                <div className="card-label">Animaux</div>
                            </div>
                        </div>
                        <div className="floating-card card-2">
                            <MdPregnantWoman className="card-icon" />
                            <div>
                                <div className="card-number">89</div>
                                <div className="card-label">En Gestation</div>
                            </div>
                        </div>
                        <div className="floating-card card-3">
                            <FaChartLine className="card-icon" />
                            <div>
                                <div className="card-number">+18%</div>
                                <div className="card-label">Performance</div>
                            </div>
                        </div>
                    </div>
                </div>
                
                {/* Screenshots Carousel */}
                
            </section>

            {/* Image Modal */}
            {selectedImage && (
                <div 
                    className="image-modal-overlay"
                    onClick={() => setSelectedImage(null)}
                >
                    <div className="image-modal-content">
                        <button 
                            className="image-modal-close"
                            onClick={() => setSelectedImage(null)}
                        >
                            ✕
                        </button>
                        <img 
                            src={selectedImage.src} 
                            alt={selectedImage.alt}
                            className="image-modal-img"
                        />
                        <p className="image-modal-caption">{selectedImage.alt}</p>
                    </div>
                </div>
            )}

            {/* Stats Section */}
            <section className="stats-section1">
                <div className="stats-repro">
                    <div className='text-repro'>
                        <h1>Circle de Reproduction</h1>
                        <p>Le cercle de reproduction représente le cycle reproductif de l’animal, depuis son entrée en âge de reproduction jusqu’à la naissance et la reprise du cycle.
                        Il permet de suivre les différentes étapes comme la maturité, la saillie, la gestation, la mise bas et le repos post-partum.
                        Cet outil aide l’éleveur à planifier les interventions, éviter les retards de reproduction et optimiser la productivité du troupeau.</p>
                    </div>
                    <img src={screenshots[4].src} alt={screenshots[4].alt} onClick={() => setSelectedImage(screenshots[4])} />
                </div>
                <div className="container1">
                    <div className="stats-grid1">
                        {stats.map((stat, index) => (
                            <div key={index} className="stat-item1">
                                <div className="stat-number1">{stat.number}</div>
                                <div className="stat-label1">{stat.label}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Features Section */}
            <section id="features" className="features-section1">
                <div className="container1">
                    <div className="section-header1">
                        <h2 className="section-title1">Fonctionnalités Puissantes</h2>
                        <p className="section-subtitle1">
                            Tout ce dont vous avez besoin pour gérer votre élevage efficacement
                        </p>
                    </div>
                    <div className="features-grid1">
                        {features.map((feature, index) => (
                            <div key={index} className="feature-card1">
                                <div className="feature-icon1">{feature.icon}</div>
                                <h3 className="feature-title1">{feature.title}</h3>
                                <p className="feature-description1">{feature.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* How It Works */}
            <section id="how-it-works" className="how-it-works-section">
                <div className="container1">
                    <div className="section-header1">
                        <h2 className="section-title1">Comment Ça Marche</h2>
                        <p className="section-subtitle1">
                            Commencez à gérer votre élevage en 3 étapes simples
                        </p>
                    </div>
                    <div className="steps-grid1">
                        {howItWorks.map((step, index) => (
                            <div key={index} className="step-card1">
                                <div className="step-number1">{step.step}</div>
                                <h3 className="step-title1">{step.title}</h3>
                                <p className="step-description1">{step.description}</p>
                                {index < howItWorks.length - 1 && (
                                    <div className="step-arrow">→</div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Benefits Section */}
            <section id="benefits" className="benefits-section1">
                <div className="container1">
                    <div className="benefits-content1">
                        <div className="benefits-left1">
                            <h2 className="section-title1">Pourquoi Choisir Notre Solution?</h2>
                            <p className="section-subtitle1">
                                Optimisez votre exploitation avec des outils modernes et efficaces
                            </p>
                            <div className="benefits-list1">
                                {benefits.map((benefit, index) => (
                                    <div key={index} className="benefit-item1">
                                        <div className="benefit-icon1">{benefit.icon}</div>
                                        <span>{benefit.text}</span>
                                    </div>
                                ))}
                            </div>
                            <button 
                                className="btn-primary"
                                onClick={() => navigate('/signup')}
                            >
                                Commencer Maintenant
                                <FaArrowRight />
                            </button>
                        </div>
                        <div className="benefits-right">
                            <div className="benefit-visual">
                                <div className="visual-item">
                                    <GiBabyBottle className="visual-icon" />
                                    <span>Suivi Vêlage</span>
                                </div>
                                <div className="visual-item">
                                    <FaHeartbeat className="visual-icon" />
                                    <span>Santé Animale</span>
                                </div>
                                <div className="visual-item">
                                    <GiMilkCarton className="visual-icon" />
                                    <span>Production Laitière</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="cta-section">
                <div className="container1">
                    <div className="cta-content">
                        <h2>Prêt à Transformer Votre Élevage?</h2>
                        <p>Rejoignez des centaines d'éleveurs qui nous font déjà confiance</p>
                        <button 
                            className="btn-cta"
                            onClick={() => navigate('/signup')}
                        >
                            Commencer Gratuitement
                            <FaArrowRight />
                        </button>
                    </div>
                </div>
            </section>

            {/* Footer */}
            <footer className="landing-footer">
                <div className="container1">
                    <div className="footer-content1">
                        <div className="footer-section1">
                            <div className="footer-logo1">
                                <FaCow className="logo-icon1" />
                                <span>Gestion des Animaux</span>
                            </div>
                            <p>Solution moderne pour la gestion d'élevage </p>
                        </div>
                        <div className="footer-section1">
                            <h4>Produit</h4>
                            <a href="#features">Fonctionnalités</a>
                            <a href="#how-it-works">Comment ça marche</a>
                            <a href="#benefits">Avantages</a>
                        </div>
                        <div className="footer-section">
                            <h4>Support</h4>
                            <a href="#">Documentation</a>
                            <a href="mailto:contact@ghaythapp.com">Contact</a>
                            <a href="#">FAQ</a>
                        </div>
                        <div className="footer-section1">
                            <h4>Légal</h4>
                            <a href="#">Politique de confidentialité</a>
                            <a href="#">Conditions d'utilisation</a>
                        </div>
                    </div>
                    <div className="footer-bottom1">
                        <p>&copy; 2026 GHAYTHAPP - Tous droits réservés.</p>
                    </div>
                </div>
            </footer>
        </div>
    );
}